e4.forms = {
    init: function () {
        if ( jQuery( '.js-e-form-dw, form[data-validate="true"]' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.jQueryValidate, function () {
                e4.forms.validate.init();
                e4.forms.mailchimp.init();
            } );
        }
        if ( jQuery( 'select' ).length > 0 ) {
            e4.util.require.js( e4.settings.require.bootstrapMultiselect );
        }
        e4.forms.toggleState();
        e4.forms.setSubmitPage();
    },
    setSubmitPage: function () {
        jQuery( '.js-e-form-dw' ).find( 'input[name="SubmitPage"]' ).val( location.href );
    },
    toggleState: function () {
        //Toggle class on form groups to focus active fields and labels.
        jQuery( '.js-e-form-dw' ).find( '.form-group :input' ).on( 'focus blur', function ( event ) {
            var jThisFormGroup = jQuery( this ).closest( '.form-group' );
            if ( event.type === 'focus' ) {
                jThisFormGroup.addClass( 'has-focus' );
            }
            else {
                jThisFormGroup.removeClass( 'has-focus' );
            }
        } );
    },
    validate: {
        init: function () {
            if ( jQuery( '.js-e-form-dw, form[data-validate="true"]' ).length > 0 ) {
                e4.forms.validate.loadTranslations();
                e4.forms.validate.setDefaults();
                e4.forms.validate.bindEvents();
            }
        },
        setDefaults: function () {
            //Set validation plugin default settings.
            jQuery.validator.setDefaults( {
                //debug: true,
                validClass: 'is-valid',
                errorClass: 'is-invalid',
                highlight: function ( domElm, strClassError /*, strClassValid */ ) {
                    jQuery( domElm ).addClass( strClassError ).closest( '.form-group' ).addClass( strClassError );
                },
                unhighlight: function ( domElm, strClassError /*, strClassValid */ ) {
                    jQuery( domElm ).removeClass( strClassError ).closest( '.form-group' ).removeClass( strClassError );
                },
                errorPlacement: function ( jError, jElement ) {
                    var jFormGroup = jElement.closest( '.form-group' ),
                        jFormValidationMsg = jFormGroup.find( '.js-e-form-validation-msg' );
                    jError.addClass( 'form-text small invalid-feedback' );
                    if ( jFormValidationMsg.length === 1 ) {
                        jFormValidationMsg.replaceWith( jError );
                    }
                    else {
                        jFormGroup.append( jError );
                    }
                },
                focusInvalid: false,
                invalidHandler: function ( form, validator ) {
                    var jFirstError = jQuery( validator.invalidElements()[ 0 ] );
                    if ( e4.util.isInViewport( jFirstError ) === true ) {
                        validator.focusInvalid();
                    }
                    else {
                        jFirstError.focus();
                        e4.scrollToAnchor.animate( jFirstError.closest( '.form-group' ).offset().top * 0.875, e4.header.hide );
                    }
                },
                submitHandler: function ( form ) {
                    if ( jQuery( form ).is( '.js-e-form-dw' ) === true ) {
                        //Read Dynamicweb spam script from inline script block inside the forms.
                        e4.data.forms.dwSpamScripts[ form.id ]( form );
                        // console.log( e4.data.forms.dwSpamScripts );
                    }
                    form.submit();
                }
            } );
        },
        bindEvents: function () {
            //Bind validation method to all Dynamiweb forms and custom forms with data-validate="true" using default settings.
            jQuery( '.js-e-form-dw, form[data-validate="true"]' ).each( function () {
                jQuery( this ).validate();
            } );
        },
        loadTranslations: function () {
            var strLang = e4.settings.lang;
            if ( strLang !== 'en' ) {
                if ( strLang === 'nb' || strLang === 'nn' ) {
                    strLang = 'no';
                }
                else if ( strLang === 'se' ) {
                    strLang = 'sv';
                }
                // Load validation messages from cdn, and then extend if custom messages are set.
                e4.util.require.js( {
                    //test: undefined,
                    url: '//ajax.aspnetcdn.com/ajax/jquery.validate/1.17.0/localization/messages_' + strLang + '.js',
                    fallback: '/files/system/espresso/design/_assets/js/vendor/jquery.validate.messages_' + strLang + '.js',
                    callback: function () {
                        e4.forms.validate.extendTranslations( strLang );
                    }
                } );
            }
            else {
                e4.forms.validate.extendTranslations( strLang );
            }
        },
        extendTranslations: function ( strLang ) {
            if ( e4.settings.forms.validate.messages[ strLang ] !== undefined ) {
                jQuery.extend( jQuery.validator.messages, e4.settings.forms.validate.messages[ strLang ] );
            }
        }
    },
    mailchimp: {
        init: function () {
            if ( jQuery( '.js-e-form-dw-mailchimp-signup' ).length > 0 ) {
                e4.forms.mailchimp.setSubmitHandler();
            }
        },
        setSubmitHandler: function () {
            jQuery( '.js-e-form-dw-mailchimp-signup' ).data( 'validator' ).settings.submitHandler = e4.forms.mailchimp.submitHandler;
        },
        submitHandler: function ( form ) {
            var jForm = jQuery( form );
            jQuery.ajax( {
                type: jForm.attr( 'method' ),
                url: jForm.find( 'input[name="MailChimp_SignUpURL"]' ).val().replace( '/post?', '/post-json?' ),
                data: jForm.serialize(),
                timeout: 1000,
                cache: false,
                dataType: 'jsonp',
                jsonp: 'c',
                context: form
            } ).always( function ( data ) {
                e4.forms.mailchimp.responseHandler( this, data );
            } );
        },
        responseHandler: function ( form, data ) {
            //console.log( form, data );
            var jForm = jQuery( form ),
                jMailChimpSignUp = jForm.closest( '.js-e-mailchimp-signup' );
            jMailChimpSignUp.find( '.js-e-msg' ).removeClass( 'show' );
            if ( data.result === 'success' ) {
                var jMsgSuccess = jMailChimpSignUp.find( '.js-e-msg-success' );
                if ( jMsgSuccess.html() === '' ) {
                    jMsgSuccess.html( data.msg );
                }
                jMailChimpSignUp.css( {
                    'min-height': ( function () {
                        return jMailChimpSignUp.height();
                    } )()
                } );
                jForm.fadeOut( e4.settings.animation.speed, function () {
                    jMsgSuccess.addClass( 'show' );
                } );
            }
            else if ( data.result === 'error' && data.msg.split( ' ' )[ 0 ] === jForm.find( 'input[name="EMAIL"]' ).val() ) {
                var jMsgMailExists = jMailChimpSignUp.find( '.js-e-msg-mail-exists' );
                if ( jMsgMailExists.html() === '' ) {
                    jMsgMailExists.html( data.msg );
                }
                else {
                    jMsgMailExists.html( jMsgMailExists.html().replace( '{{Email}}', jForm.find( 'input[name="EMAIL"]' ).val() ) );
                }
                jMsgMailExists.addClass( 'show' );
            }
            else {
                var jMsgError = jMailChimpSignUp.find( '.js-e-msg-error' );
                if ( jMsgError.html() === '' ) {
                    jMsgError.html( data.msg );
                }
                jMsgError.addClass( 'show' );
            }
        }
    }
};

/*
 jQuery.validator.addMethod( 'localizedNumber', function ( value, domElm ) {
 var regExpLocalizedNumber = new RegExp( '^-?(?:\\d+|\\d{1,3}(?:\\' + vetoryl.logbook.number.intergerSeperator + '\\d{3})+)?(?:\\' + vetoryl.logbook.number.decimalSeperator + '\\d+)?$' );
 return this.optional( domElm ) || regExpLocalizedNumber.test( value );
 }, jQuery.validator.messages.number );
 */

